import type { RewardBadgeCategoryType } from "../types";

export const VISIBLE_REWARD_CATEGORIES: ReadonlyArray<RewardBadgeCategoryType> = [
  "general",
  "futures",
];

const VISIBLE_CATEGORY_SET = new Set<RewardBadgeCategoryType>(
  VISIBLE_REWARD_CATEGORIES
);

export function isVisibleRewardCategory(
  category: string | undefined | null
): category is RewardBadgeCategoryType {
  if (!category) {
    return false;
  }
  return VISIBLE_CATEGORY_SET.has(category as RewardBadgeCategoryType);
}
